import { gql } from "@apollo/client";
export const ADMIN_WINERY_MEMBER_DELETE = gql `
  mutation AdminWineryMemberDelete($input: AdminWineryMemberDeleteInput!) {
    AdminWineryMemberDelete(input: $input)
  }
`;
